import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, toHandlers as _toHandlers, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d50948d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex align-items-center justify-content-center icon-section pe-24 pe-lg-12 pe-xl-24" }
const _hoisted_2 = ["title"]
const _hoisted_3 = {
  key: 1,
  class: "icon icon-user-circle",
  title: "En persona"
}
const _hoisted_4 = { class: "d-flex flex-column" }
const _hoisted_5 = { class: "date text-tertiary fw-bold" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "description" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center justify-content-center ms-auto ps-8" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon icon-expand-right text-primary" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.consultations, (consultation, index) => {
    return (_openBlock(), _createElementBlock("div", {
      class: "item",
      key: index
    }, [
      _createElementVNode("div", _mergeProps({
        class: ["d-flex align-items-center item-content", {'active': _ctx.currentConsultation?.id === consultation.id}]
      }, _toHandlers(_ctx.canShowConsultation
           ? { click: () => _ctx.setConsultation(consultation) } : {})), [
        _createElementVNode("div", _hoisted_1, [
          (consultation.via === 'phone' || consultation.via === 'videocall')
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "icon icon-phone",
                title: consultation.via === 'phone' ? 'Teléfono' : 'Videollamada'
              }, null, 8, _hoisted_2))
            : (_openBlock(), _createElementBlock("span", _hoisted_3))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$str.formatDateTime(consultation.initDate)), 1),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.type(consultation)), 1),
          _createElementVNode("div", _hoisted_7, _toDisplayString(!!consultation.clinic ? consultation.clinic.name : _ctx.$t('- Sin clínica asociada -')), 1)
        ]),
        _hoisted_8
      ], 16)
    ]))
  }), 128))
}